export default __webpack_public_path__ + "assets/pdf/Phishing Simulation Setup Guide for Office 365.pdf";